<section class="riesgo-dialog historial-riesgo-dialog">
  <header class="riesgo-dialog__header">
    <div>
      <div class="riesgo-dialog__eyebrow">Riesgo {{ data?.id }}</div>
      <h2>Historial de cambios</h2>
      <p>Consulte las versiones y responsables registrados para este riesgo.</p>
    </div>
    <button type="button" mat-icon-button class="riesgo-dialog__close" (click)="closeModal()"
      aria-label="Cerrar historial de cambios" matTooltip="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div mat-dialog-content class="riesgo-dialog__content">
    <div class="table-responsive riesgo-dialog__table-wrap">
      <table #tblCambios id="dataTableCambios" class="table table-striped table-no-bordered table-hover" datatable
        [dtOptions]="tblCambiosPaginacion" cellspacing="0">
        <thead>
          <tr>
            <th>Versión</th>
            <th>Descripción</th>
            <th>Elaboró</th>
            <th>Autorizó</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of listHistorial">
            <td>{{ row.version }}</td>
            <td>{{ row.descripcion }}</td>
            <td>{{ row.elabora }}</td>
            <td>{{ row.autoriza }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <footer class="riesgo-dialog__footer">
    <button type="button" mat-stroked-button class="app-form-btn app-form-btn--secondary" (click)="closeModal()">
      Cerrar
    </button>
  </footer>
</section>
